import { useEffect, useState } from 'react';
import { api } from '../api/client';
import { useEntitlements } from '../subscription/offers';
import { useT } from '../i18n/i18n';
import { usageLine, usageShare, type MediaUsage } from './usage';
import { useMediaVersion } from './media';
import MediaManager from './MediaManager';

export default function StorageUsage() {
  const t = useT();
  const entitlements = useEntitlements();
  const [usage, setUsage] = useState<MediaUsage | null>(null);
  const version = useMediaVersion();
  const entitled = !!entitlements && (entitlements.main || entitlements.talkBoard);

  useEffect(() => {
    if (!entitled) return;
    api<MediaUsage>('/media/usage', { token: true }).then(setUsage).catch(() => setUsage(null));
  }, [entitled, version]);

  if (!usage) return null;
  const share = Math.min(1, usageShare(usage));
  return (
    <section className="sub-usage" aria-labelledby="sub-usage-h">
      <h3 id="sub-usage-h">{t('Your photos and recordings')}</h3>
      <meter min={0} max={1} low={0.8} high={0.95} optimum={0} value={share} aria-labelledby="sub-usage-h">
        {Math.round(share * 100)}%
      </meter>
      <p className="field-hint">
        {usageLine(usage, t)}
        {share >= 0.95 && ` ${t('Remove photos or recordings you no longer need to make room for new ones.')}`}
      </p>
      <MediaManager />
    </section>
  );
}
